<template>
  <v-app>
    <v-app-bar color="grey darken-3" class="raiseNavbar" app>
      <v-toolbar-title class="display-1 white--text">
        <a @click='redirect("/")' class="logo">
          <span v-if="$vuetify.breakpoint.smAndUp">Nettex</span>
          <h1 v-else>N</h1>
        </a>
      </v-toolbar-title>
      <template v-slot:extension>
        <v-tabs
          :value="-1"
          color="green lighten-3"
          dark>
          <v-tab @click='redirect("/")' class="ml-0">Home</v-tab>
          <v-tab @click='redirect("/gallery")'>Gallery</v-tab>
        </v-tabs>
      </template>
    </v-app-bar>

    <v-content>
      <v-container class="pa-0 mt-12">
        <v-row>
          <v-col cols="10" sm="8" md="6" class="mx-auto text-center grey--text text--darken-3">
            <!-- <h2>Welcome to Nettex's Auth Server</!-->
            <!--            <p>Please enter your details below.</p>-->
            <!-- <v-divider class="mb-3" /> -->
            <router-view />
            <!-- <LogIn v-show="screen === 0" @signUp='screen = 1' @resetPassword='screen = 2' />
            <SignUp v-show="screen === 1" @login='screen = 0' />
            <ResetPassword v-show="screen !== 0 && screen !== 1" @login='screen = 0' @signUp='screen = 1' /> -->
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
const www = 'https://www.nettex.com.au'
export default {
  name: 'App',
  methods: {
    redirect(path) {
      location.href = www + path
    }
  },
}
</script>

<style scoped>
.logo {
  text-decoration: none;
  color: inherit;
}
</style>
